export default __webpack_public_path__ + "static/media/vg-home-logo.18fcaa2d.svg";